import { SmsHealthHistoryCell } from "@/components/CellRenderer";
import { Table } from "@/components/Table";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";
import { useGetKlaviyoHealthCheckHistoryTable } from "@/requests/hooks/collect";
import { createColumnHelper } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const KlaviyoHealthHistory = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const columnHelper = createColumnHelper<IKlaviyoHealthHistory>();

  const columns = [
    columnHelper.accessor("date", {
      header: t("sms.healthCheckHistory.klaviyo.table.columns.date"),
      size: 175,
    }),
    columnHelper.accessor("secondOptInContentStatus", {
      header: t("sms.healthCheckHistory.klaviyo.table.columns.request"),
      cell: info => <SmsHealthHistoryCell value={info.getValue()} />,
      meta: {
        align: "center",
      },
    }),
    columnHelper.accessor("smsListDoubleOptInEnabled", {
      header: t("sms.healthCheckHistory.klaviyo.table.columns.smsList"),
      cell: info => <SmsHealthHistoryCell value={info.getValue()} />,
      meta: {
        align: "center",
      },
    }),
  ];

  return (
    <>
      <div className="mb-30 mt-50">
        <TypographyContainer>
          <HeaderTextBlock
            headingText={t("sms.healthCheckHistory.klaviyo.header.heading")}
            descriptionText={t(
              "sms.healthCheckHistory.klaviyo.header.description",
            )}
          />
        </TypographyContainer>
      </div>
      <Table
        columns={columns}
        queryKey={["collect", "sms", "healthCheckHistory", "klaviyo"]}
        queryHook={useGetKlaviyoHealthCheckHistoryTable}
        filters={{
          month: searchParams.get("month")!,
        }}
        isSearchEnabled={false}
      />
    </>
  );
};

export default KlaviyoHealthHistory;
